export const lsSetItem = (key: string, data: string) => {
	try {
		localStorage.setItem(key, data);
	} catch (e) {}
};

export const lsGetItem = (key: string): string | null => {
	let data: string | null = null;
	try {
		data = localStorage.getItem(key);
	} catch (e) {}
	return data;
};

export const lsRemoveItem = (key: string) => {
	try {
		localStorage.removeItem(key);
	} catch (e) {}
};
